export const mobilePhoneDigits = (value = '') => String(value).replace(/\D/g, '');

export const formatMobilePhone = (value = '') => {
  const digits = mobilePhoneDigits(value).slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
};

export const isValidMobilePhone = (value = '') => /^010\d{8}$/.test(mobilePhoneDigits(value));
